import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import TextInput from 'screens/components/basic/TextInput';
import Panel from 'screens/components/basic/Panel';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class FaqContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            faqDialog: false
        };
    }

    openFaqDialog = () => {
        this.setState({ faqDialog: true });
    }

    closeFaqDialog = () => {
        this.setState({ faqDialog: false });
    }

    getQuestion = () => {
        return (
            [
                {
                    question: "Where Do I Upload My ID?",
                    category: "New Customer Information",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.openFaqDialog()}
                            />
                        </div>
                    )
                },
                {
                    question: "What Happens If My Package Isn't Delivered?",
                    category: "Shipping",
                    icons: (
                        <div>
                            <Button
                                type="EditButton"
                                label="Edit"
                                primary={true}
                                onTouchTap={() => this.openFaqDialog()}
                            />
                        </div>
                    )
                }
            ]
        );
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active"><Link to={LOOKUP.menu.admin.writing.faq.link}>{LOOKUP.menu.admin.writing.faq.text}</Link></li>
                </ol>
                <h2>{LOOKUP.menu.admin.writing.faq.text}</h2>
            </div>
        );

        const sideContent = (
            <Panel title="Toolbox">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center margin_button">
                    <Button name="buttonSave"
                        className="toolbox-button"
                        label={LOOKUP.menu.admin.common.addQuestion.label}
                        primary={true}
                        onTouchTap={() => this.openFaqDialog()} />
                </div>
            </Panel>
        );

        return (
            <div>
                <ContainerDivided headerContent={header} sideContent={sideContent}>
                    <GenericTable
                        className="table_center"
                        tableBodyClassName="table_center"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={true}
                        columns={LOOKUP.menu.admin.writing.faq.tableColumns}
                        rows={this.getQuestion()}
                        stripedRows={true}
                    />
                </ContainerDivided>
                <DialogInput
                    title={LOOKUP.menu.admin.writing.faq.title}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeFaqDialog()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label={LOOKUP.menu.admin.common.add.label}
                            primary={true}
                            onTouchTap={() => this.closeFaqDialog()}
                        />]}
                    modal={true}
                    open={this.state.faqDialog}
                    className="container_scroll"
                >
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <TextInput
                                fullWidth={true}
                                name="storeCity"
                                floatingLabelText={LOOKUP.menu.admin.writing.faq.question.label}
                                hintText={LOOKUP.menu.admin.writing.faq.question.hintText}
                                maxLength={20} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <TextInput
                                fullWidth={true}
                                name="storeCity"
                                floatingLabelText={LOOKUP.menu.admin.writing.faq.category.label}
                                hintText={LOOKUP.menu.admin.writing.faq.category.hintText}
                                maxLength={20} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <h4 className="ml-1 mb-2 mt-3">ANSWER</h4>
                    <Editor
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="faq_answer_dialog"
                    />
                </DialogInput>
            </div>
        );
    }
}


export default FaqContent;